import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Environment } from '../classes/environment';

export interface StartRegistrationRequest {
  instanceName: string;
  email: string;
}
export interface CompleteRegistrationRequest {
  token: string;
  username: string;
  password: string;
  company: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  newsletter: boolean;
}

@Injectable({ providedIn: 'root' })
export class RegistrationService {
  constructor(
    @Inject('environment') private environment: Environment,
    private http: HttpClient,
  ) {}

  /** Schritt 1 – sendet Instanz & E-Mail, Backend antwortet 202 */
  startRegistration(body: StartRegistrationRequest): Observable<void> {
    return this.http.post<void>(`${this.environment.backendUrl}registration`, body);
  }

  /** Schritt 2 – vollständige Registrierung mit Token abschließen */
  completeRegistration(body: CompleteRegistrationRequest): Observable<void> {
    return this.http.post<void>(`${this.environment.backendUrl}registration/complete`, body);
  }
}
